import type { ViewOptionsGroup } from '@/engine/app/interfaces.ts';

export const devices: ViewOptionsGroup = {
  id: 'devices',
  label: 'Devices',
  children: []
};

export const leftHeart: ViewOptionsGroup = {
  id: 'leftHeart',
  label: 'Left Heart',
  children: []
};

export const rightHeart: ViewOptionsGroup = {
  id: 'rightHeart',
  label: 'Right Heart',
  children: []
};

export const anatomy: ViewOptionsGroup = {
  id: 'anatomy',
  label: 'Anatomy',
  children: []
};
